export const getPriceInCurrency = (prices, currency) => {
  const price = prices && prices.find(({code}) => code === currency);

  return price && price.price;
};


export function formatPrice(cents) {
  let int = Math.floor(cents / 100.0);

  let fract = Math.round(cents - int * 100).toString();
  fract = ('00' + fract).slice(-2);

  if (int) {int = int.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1 ');}

  return `${int},${fract}`;
}



// WEBPACK FOOTER //
// ./src/utils/price.js